import axios from 'axios';
import { IErrorMessageApi } from 'models/login';

async function validateRecaptcha(token: string): Promise<boolean> {
  try {
    const response = await axios.post(`${process.env.REACT_APP_USER_SESSION_API}/usuarios-ies/recaptcha`, {
      token
    })
    if (response.data) {
      return response.data;
    } else {
      return Promise.reject(IErrorMessageApi.TOKEN_RECAPTCHA_INVALIDO);
    }
  } catch (error) {
    return Promise.reject(error);
  }
}

export default validateRecaptcha;